import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocalization } from "../../i18n/LocalizationProvider";

export default function LanguageToggle({ size = "small" }) {
    const { language, setLanguage, isRTL } = useLocalization();
    const { t } = useTranslation();

    return (
        <ToggleButtonGroup
            size={size}
            exclusive
            value={language}
            onChange={(_, next) => {
                if (!next) return;
                setLanguage(next);
            }}
            aria-label={t("common.language")}
            sx={{ flexDirection: isRTL ? "row-reverse" : "row" }}
        >
            <ToggleButton value="en" aria-label={t("common.english")}>
                {t("toggle.en")}
            </ToggleButton>
            <ToggleButton value="ar" aria-label={t("common.arabic")}>
                {t("toggle.ar")}
            </ToggleButton>
        </ToggleButtonGroup>
    );
}
